export default __webpack_public_path__ + "static/media/05_photo.3288d9c2.jpeg";